import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const isRTL = i18n.language === 'ar';
  const currentLanguage = i18n.language;

  useEffect(() => {
    // Update document direction and language
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLanguage;
    
    // Add/remove RTL class for styling
    if (isRTL) {
      document.documentElement.classList.add('rtl');
    } else {
      document.documentElement.classList.remove('rtl');
    }
  }, [isRTL, currentLanguage]);

  return {
    currentLanguage,
    isRTL,
    changeLanguage,
    languages: [
      { code: 'en', name: 'English', nativeName: 'EN' },
      { code: 'ar', name: 'Arabic', nativeName: 'AR' },
    ],
  };
};

export const useLocalizedContent = () => {
  const { i18n } = useTranslation();
  
  const getLocalizedText = (content: { en: string; ar: string }) => {
    return content[i18n.language as 'en' | 'ar'] || content.en;
  };

  return { getLocalizedText };
};